import React from 'react';
import { useParams } from 'react-router-dom';
import './PaymentSuccess.css';

const ExamError = () => {
  const { examId } = useParams(); // Get examId from URL parameters

   return (
    <div className="payment-success-container">
      <div className="payment-success-card">
        <h1 className="payment-success-title">Exam Attempt Error!</h1>
        <p className="payment-success-message" style={{textAlign: 'justify'}}>
         We’re sorry, but there was an issue with your exam attempt. <br />
          It appears you may have attempted the exam outside your selected time slot or encountered another issue.
        </p>
        <p className="payment-success-message" style={{textAlign: 'justify'}}>
         Please verify your scheduled exam time or contact our support team for assistance. You can also check your email for additional details.
        </p>
        <a href="/" className="payment-success-button">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default ExamError;